
import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { InputDialog } from '../../input-dialog/dialog-input';
import { SettingsService } from 'src/app/settings/settings.service';;
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  CertificadoValidacionService, ResultadoValidacion, resultadoValidacion, textoErrorValidar,
  TEXTO_GUARDADO_SIN_VERIFICAR,
} from './certificado-validacion';
declare var $ :any;


@Component({
    selector: 'app-certificado',
    templateUrl: './certificado.html',
    styleUrls: ['./certificado.less'],
    standalone: false
})


export class Certificado implements OnInit {

  @Input() id_company:any;
  @Input() data:any;
  @Input() token:any;

  @Input() id_sim:any;

  valForm: FormGroup;
  run: any;
  rut:any;
  clave_pfx:any;
  file:any;
  clave_sii:any;

  success_certificado: boolean = false;
  message_pfx: string = "Certificado SII inválido."
  success_clave: boolean = false;
  success_rut: boolean = false;

  // Mensajes del backend por campo y uno general (antes se marcaban los dos campos como
  // inválidos sin decir por qué).
  message_clave: string = "Clave del Certificado Digital inválida.";
  message_rut: string = "RUT inválido.";
  error_general: string = "";

  // Después de «Guardar» con 200 se valida una vez en el SII y se muestra el resultado acá.
  paso: 'formulario' | 'guardando' | 'verificando' | 'resultado' = 'formulario';
  resultado: ResultadoValidacion | null = null;
  sin_verificar: string = "";

  // El RUT autorizado lo lee el backend del certificado. El campo sólo aparece si no pudo
  // leerlo (RUT_AUTORIZADO_REQUERIDO) o si el ingresado no es el del certificado
  // (RUT_TITULAR_NO_COINCIDE).
  mostrar_rut: boolean = false;
  rut_titular: string = "";
  // Por qué se pide el RUT (no se pudo leer del certificado, o el certificado es de otra persona).
  aviso_rut: string = "";
  guardado: boolean = false;

  get desactivar_guardar(): boolean {
    const v = this.valForm.value;
    return this.paso != 'formulario' || this.saving_certificado || !this.success_certificado
      || !v.certificado_sii || !v.clave_certificado
      || (this.mostrar_rut && !v.rut_autorizado);
  }

  constructor(public snackBar: MatSnackBar,
    private router: Router, public dialog: MatDialog,
    public settings: SettingsService, private _formBuilder: FormBuilder, private dialogRef: MatDialogRef<Certificado>,
    private validacion: CertificadoValidacionService) {


    this.valForm = this._formBuilder.group({
      certificado_sii: ['', Validators.required],
      clave_certificado: ['', Validators.required],
      rut_autorizado: [''],
    });

  }

  ngOnInit() {

    this.get_credenciales()

  }

  get_credenciales() {
    this.rut = this.data?.rut_autorizado;
    this.clave_sii = this.data?.clave_sii;
    this.file = this.data?.archivo_pfx;


    if (this.file != null && this.file != "" && this.file != undefined) {
      this.valForm.controls['certificado_sii'].setValue(this.file)
      this.success_certificado = true
    }

    // La clave NO se prellena: lo que llega es el marcador «••••••••», no la clave, y el backend
    // lo rechaza como clave. Hay que escribirla cada vez.
    // El RUT tampoco: lo toma el backend del certificado.
  }

  open_certificado() {
    $("#certificado_pfx").trigger('click');
  }

  //CLAVE CERTIFICADO
  saving_clave:boolean=false;
  subir_clave_pfx($e:any) {
    this.clave_pfx = $e.target.value;
    this.success_clave = this.clave_pfx != "";
    this.error_general = "";
  }

  //RUT AUTORIZADO
  saving_rut:boolean=false;
  subir_rut_autorizado($e:any) {
    let run = $e.target.value;
    run = run.toUpperCase();
    this.error_general = "";

    if (run == "") {
      this.success_rut = false;
    } else {
      let dot = /\./gi
      let st = run.replace("-", "");
      st = st.replace(dot, "")
      let arr = st.split("");
      let st_out = "";
      for (let i = 0; i < arr.length; i++) {
        st_out = st_out + arr[i];
        if (i == arr.length - 2) {
          st_out = st_out + "-"
        }
      }
      this.rut = st_out.toUpperCase()
      this.valForm.controls['rut_autorizado'].setValue(this.rut)
      this.success_rut = true;
    }
  }

  update() {

    this.dialogRef.close(this.guardado)

    if (this.guardado) {
      this.snackBar.open("Datos de Certificado Digital Actualizado", "Aceptar", {
        duration: 10000,
        panelClass: "simpli-snack"
      });
    }

  }

  // El texto que manda el backend (formato de `handlers/error_handler.py`, o el de DRF sin él).
  static errores_backend(bd: any): { campos: any, general: string } {
    const cuerpo: any = bd?.error || {};
    const errores: any = cuerpo?.error?.errors ?? cuerpo?.errors ?? cuerpo;
    const texto = (v: any): string => Array.isArray(v) ? v.map(x => String(x)).join(" ") : (v == null ? "" : String(v));
    if (errores && typeof errores == 'object' && !Array.isArray(errores)) {
      const campos: any = {};
      for (const k of Object.keys(errores)) {
        if (k != 'non_field_errors' && k != 'detail') campos[k] = texto(errores[k]);
      }
      return { campos, general: texto(errores.non_field_errors) || texto(errores.detail) };
    }
    return { campos: {}, general: texto(errores) };
  }

  open_input_dialog(title:any,subtitle:any,mensajeprincipal:any, mensajenegrita:any,icon:any,coloricon:any) {
    const dialogRef = this.dialog.open(InputDialog, {
      width: '700px',
      autoFocus: false,
    });
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.subtitle = subtitle;
    dialogRef.componentInstance.mensajeprincipal = mensajeprincipal;
    dialogRef.componentInstance.mensajenegrita = mensajenegrita;
    dialogRef.componentInstance.icon = icon;
    dialogRef.componentInstance.coloricon = coloricon;

    dialogRef.afterClosed().subscribe((result:any) => {

    });
  }

  // Back nuevo app cliente
  saving_certificado:boolean=false;
  // El `.pfx` elegido. Ya no se sube al elegirlo: `cargar-certificado-digital` reemplazaba el
  // certificado y borraba la clave antes de saber si la nueva servía, y si después fallaba el
  // guardado la empresa quedaba sin certificado. Ahora va junto con la clave en el mismo `PUT`
  // (LemuBackend #6544): el backend sólo lo guarda si la clave lo abre y está vigente.
  archivo_nuevo: File | null = null;
  static readonly TAMANO_MAXIMO_PFX = 50 * 1024 * 1024;

  subir_certificado_new($e:any){
    this.message_pfx = "Certificado SII inválido.";
    this.error_general = "";
    this.valForm.controls['certificado_sii'].setErrors(null);
    const archivo: File | undefined = $e.target.files?.[0];
    $e.target.value = "";
    if (!archivo) return;

    const error = !archivo.name.toLowerCase().endsWith('.pfx') ? "El certificado tiene que ser un archivo .pfx."
      : archivo.size > Certificado.TAMANO_MAXIMO_PFX ? "El certificado no puede pesar más de 50 MB."
      : "";
    if (error) {
      this.message_pfx = error;
      this.valForm.controls['certificado_sii'].setErrors({ 'incorrect': true });
      this.valForm.controls['certificado_sii'].markAsTouched();
      return;
    }

    // La clave es la de este archivo: hay que escribirla de nuevo.
    this.archivo_nuevo = archivo;
    this.file = archivo.name;
    this.valForm.controls['certificado_sii'].setValue(archivo.name);
    this.valForm.controls['clave_certificado'].setValue("");
    this.valForm.controls['rut_autorizado'].setValue("");
    this.success_clave = false;
    this.success_rut = false;
    this.mostrar_rut = false;
    this.rut_titular = "";
    this.aviso_rut = "";
    this.success_certificado = true;
  }


  async put_certificado(){
    if (this.desactivar_guardar) return;
    this.error_general = "";
    this.aviso_rut = "";
    this.valForm.controls['rut_autorizado'].setErrors(null);
    this.valForm.controls['clave_certificado'].setErrors(null);
    this.paso = 'guardando';
    try {
      const clave = this.valForm.controls['clave_certificado'].value;
      // Sin RUT, el backend usa el del certificado. Sólo se manda si el backend pidió el campo.
      const rut = this.mostrar_rut ? this.valForm.controls['rut_autorizado'].value : "";
      let value: any;
      if (this.archivo_nuevo) {
        // Archivo, clave y RUT en una sola llamada: si algo falla, el certificado anterior sigue.
        value = new FormData();
        value.append("certificado", this.archivo_nuevo, this.archivo_nuevo.name);
        value.append("clave_pfx", clave);
        if (rut) value.append("rut_autorizado", rut);
      } else {
        value = { "clave_pfx": clave };
        if (rut) value["rut_autorizado"] = rut;
      }

      const simulacion = this.id_sim ? "?simulation_id=" + this.id_sim : "";
      const bd: any = await this.settings.get_query(3, "cliente/certificado-digital/" + this.id_company + "/" + simulacion, value);
      switch (bd.status) {
        case 200:
          this.guardado = true;
          this.archivo_nuevo = null;
          this.file = bd._body?.success?.info?.archivo_pfx || this.file;
          // `aviso` (BPC_NO_RESPONDE / BPC_CEDENTE_RECHAZADO) no se le muestra al cliente: el
          // registro en BPC sólo afecta «Ceder Envío DTE», que se hace desde Simpli, y el cliente
          // no tiene cómo arreglarlo. Si el certificado no sirve para ceder, lo dice la
          // validación en el SII que viene ahora, con qué hacer. Simpli lo ve en el log
          // `certificado_cedente_rechazado`.
          await this.validar_en_sii();
        break;
        default:
          this.paso = 'formulario';
        break;
      }

    } catch (bd:any) {
      this.paso = 'formulario';
      this.mostrar_error_put(bd);
    }
  }

  private mostrar_error_put(bd: any) {
    const { campos, general } = Certificado.errores_backend(bd);
    let marcado = false;
    if (campos.codigo == 'RUT_AUTORIZADO_REQUERIDO') {
      // No se pudo leer el RUT del certificado: lo ingresa el cliente.
      this.mostrar_rut = true;
      this.aviso_rut = "No pudimos leer el RUT de tu certificado. Ingresa el RUT del titular del certificado y guarda de nuevo.";
      marcado = true;
    } else if (campos.codigo == 'RUT_TITULAR_NO_COINCIDE') {
      // El certificado es de otra persona: se dice de quién y se propone su RUT.
      this.mostrar_rut = true;
      this.rut_titular = campos.rut_titular || "";
      const ingresado = this.valForm.controls['rut_autorizado'].value;
      this.aviso_rut = this.rut_titular
        ? `Este certificado es de ${this.rut_titular}${ingresado && ingresado != this.rut_titular ? ', no de ' + ingresado : ''}. ` +
          `Si es correcto, guarda con el RUT ${this.rut_titular}; si no, carga el certificado de la persona que corresponde.`
        : (campos.rut_autorizado || "El RUT no coincide con el de tu certificado.");
      if (this.rut_titular) {
        this.valForm.controls['rut_autorizado'].setValue(this.rut_titular);
        this.success_rut = true;
      }
      marcado = true;
    } else if (campos.rut_autorizado) {
      this.mostrar_rut = true;
      this.message_rut = campos.rut_autorizado;
      this.valForm.controls['rut_autorizado'].setErrors({ 'incorrect': true });
      marcado = true;
    }
    if (campos.certificado) {
      // El archivo (más de 50 MB): se marca en el campo del archivo.
      this.message_pfx = campos.certificado;
      this.valForm.controls['certificado_sii'].setErrors({ 'incorrect': true });
      this.valForm.controls['certificado_sii'].markAsTouched();
      marcado = true;
    }
    if (campos.clave_pfx) {
      this.message_clave = campos.clave_pfx;
      this.valForm.controls['clave_certificado'].setErrors({ 'incorrect': true });
      marcado = true;
    }
    if (general && !marcado) {
      const texto = general.toLowerCase();
      if (texto.includes('contraseña') || texto.includes('clave')) {
        this.message_clave = general;
        this.valForm.controls['clave_certificado'].setErrors({ 'incorrect': true });
      } else {
        this.error_general = general;
      }
      marcado = true;
    }
    if (!marcado) this.error_general = "No pudimos guardar tu certificado. Inténtalo de nuevo más tarde.";
    this.valForm.controls['clave_certificado'].markAsTouched();
    this.valForm.controls['rut_autorizado'].markAsTouched();
  }

  // Una sola vez, justo después de guardar: cada validación es un login al SII con el certificado.
  private async validar_en_sii() {
    this.paso = 'verificando';
    this.dialogRef.disableClose = true;
    try {
      const { status, body } = await this.validacion.validar(this.id_company);
      this.resultado = status == 200 ? resultadoValidacion(body) : null;
      if (!this.resultado) {
        this.sin_verificar = status == 200 ? TEXTO_GUARDADO_SIN_VERIFICAR : textoErrorValidar({ status }, true);
      }
    } finally {
      this.paso = 'resultado';
      this.dialogRef.disableClose = false;
    }
  }
  // Back nuevo app cliente

}
